// eslint-disable-next-line jira/restricted/react
import React, { PureComponent } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import DropdownMenu, { DropdownItemGroup, DropdownItem } from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';
import Spinner from '@atlaskit/spinner';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { defineMessages } from '@atlassian/jira-intl';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${2 * gridSize}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${3 * gridSize}px`,
});

const messages = defineMessages({
	editAction: {
		id: 'project-components.table-actions-cell-edit',
		defaultMessage: 'Edit',
		description: '',
	},
	deleteAction: {
		id: 'project-components.table-actions-cell-delete',
		defaultMessage: 'Delete',
		description: '',
	},
	moreActions: {
		id: 'project-components.table-header-more-actions',
		defaultMessage: 'More actions for {componentName}',
		description: 'Table header label for actions column',
	},
});

type Props = {
	intl: IntlShape;
	showSpinner: boolean;
	name: string;
	onEdit: () => void;
	onDelete: () => void;
};

// eslint-disable-next-line jira/react/no-class-components
class ActionsView extends PureComponent<Props> {
	onEditClicked = () => this.props.onEdit();

	onDeleteClicked = () => this.props.onDelete();

	render() {
		const {
			intl: { formatMessage },
			name,
		} = this.props;

		const IconBefore = this.props.showSpinner ? (
			<SpinnerContainer>
				<Spinner size="small" />
			</SpinnerContainer>
		) : (
			<MoreIcon
				spacing="spacious"
				label={formatMessage(messages.moreActions, { componentName: name })}
			/>
		);

		return (
			<DropdownMenu
				shouldRenderToParent
				placement="bottom-end"
				trigger={({ triggerRef, ...props }) => (
					<Button {...props} ref={triggerRef} appearance="subtle" iconBefore={IconBefore} />
				)}
			>
				<DropdownItemGroup>
					<DropdownItem onClick={this.onEditClicked}>
						{formatMessage(messages.editAction)}
					</DropdownItem>
					<DropdownItem onClick={this.onDeleteClicked}>
						{formatMessage(messages.deleteAction)}
					</DropdownItem>
				</DropdownItemGroup>
			</DropdownMenu>
		);
	}
}

export default injectIntl(ActionsView);
